export const PRICING_CATALOG_OFFERS_QUERY_KEY = ['pricingCatalogOffers'] as const;
export const PRICING_CATALOG_ACQUISITION_QUERY_KEY = ['pricingCatalogAcquisition'] as const;
